import PremierAgentPage from 'sly/premierAgent';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default PremierAgentPage;

export async function getServerSideProps({
  params,
  resolvedUrl,
}: {
  params: { slug: string };
  resolvedUrl: string;
}) {
  const { api, store } = createApiClient(apiEndpoints);
  const { slug } = params;

  try {
    const [agentPromise] = await Promise.all(
      [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getAgent.asAction({
          id: slug,
        }),
      ].map(store.dispatch)
    );

    if (agentPromise?.body?.data?.attributes?.info?.isRealEstateAgent) {
      throw new Error('Agent is a real estate agent');
    }

    if (
      !agentPromise?.body?.data?.attributes?.info?.isPro &&
      !!agentPromise?.body?.data?.attributes?.info?.url
    ) {
      return {
        redirect: {
          source: resolvedUrl,
          permanent: false,
          destination: agentPromise?.body?.data?.attributes?.info?.url,
        },
      };
    }
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
